import React, { useEffect, useState } from "react";
import "./You_may_also.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import Product_card from "../../common/common_components/product-card/Product_card";
import { useDispatch, useSelector } from "react-redux";
import { GetAllProducts } from "../../../features/admin/products/slice";
import { IDS } from "../../../utils/IDS";
import { Pagination } from "swiper/modules";
import { encodeId } from "../../../utils/common";

const You_may_also = () => {
  const toggleWishlist = (id) => {
    // setTopproducts(prev =>
    //     prev.map(item =>
    //         item.id === id ? { ...item, inWishlist: !item.inWishlist } : item
    //     )
    // );
  };

  const dispatch = useDispatch();
  const products = useSelector((state) => state.commerce.products);

  useEffect(() => {
    dispatch(GetAllProducts());
  }, [dispatch]);

  return (
    <section className="You_may_also_sec">
      <div className="container p-0">
        <Common_Title_1
          subText={"You may also like"}
          linktext={"See all"}
          link={"/all-products"}
        />

        <div className="slidersec">
          <Swiper
            modules={[Pagination]}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              0: { slidesPerView: 1.6, spaceBetween: 5 },
              485: { slidesPerView: 2, spaceBetween: 5 },
              575: { slidesPerView: 3, spaceBetween: 10 },
              768: { slidesPerView: 4, spaceBetween: 10 },
              1200: { slidesPerView: 5, spaceBetween: 15 },
            }}
            className="mySwiper pb-5"
          >
            {products?.data?.map((data) => (
              <SwiperSlide key={data.id}>
                <Product_card
                  average_rating={data.average_rating}
                  id={data.id}
                  image={IDS.IMG_URL + data.image}
                  name={data.name}
                  subname={`(${data?.p_category?.name})`}
                  oldprise={data.mrp}
                  prise={data.price}
                  link={`/product-details/${encodeId(data.id)}`}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default You_may_also;
